const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Video Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('videoImage', ['$sce', function ($sce) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      videoLink: '@'
    },
    template: require('../../templates/directives/video-image.html'),
    link: function (scope, element, attrs) {
      // Set in a watch because it is async by nature
      scope.$watch('videoLink', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          scope.videoLinkTrust = $sce.trustAsResourceUrl(scope.videoLink);

          var videoPlayer = document.getElementById('video-player');
          var canvas = document.getElementById('image-canvas');
          var context = canvas.getContext('2d');

          var canvasWidth = canvas.width;
          var canvasHeight = canvas.height;

          var draw = function(video, canvas, width, height) {
            canvas.drawImage(video, 0, 0, width, height);
            setTimeout(draw, 20, video, canvas, width, height);
          };

          draw(videoPlayer, context, canvasWidth, canvasHeight);
        }
      })
    }
  }
}]);
